import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, UrlSegment } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService, SharedDataService, Staff } from 'elbuild-ui-lib-core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { delay, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Customer, StoreEnv } from 'yf-commerce-model-ui-lib';
import { RouteGuardService, ShopCartService, WishlistService } from 'yf-commerce-ui-lib';

import { IframeService } from './shared/services/iframe.service';
import { AccountService } from './shared/services/account.service';

declare let ga: Function;
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	standalone: false
})
export class AppComponent implements AfterViewInit, OnInit {

	_loading: boolean;

	set loading(v: boolean) {

		this._loading = v;

		if (!v) {
			document.body.classList.add('loaded');

		} else {
			document.body.classList.remove('loaded');
		}
	}

	get loading(): boolean {
		return this._loading;
	}
	hidebar: boolean;
	// For Progressbar
	loaders = this.loader.progress$.pipe(
		delay(1000),
		withLatestFrom(this.loader.progress$),
		map(v => v[1]),
	);
	googletagmanager: any;
	dev: boolean;
	loggedUser: Customer;
	url: string;
	checked: boolean;

	constructor(private loader: LoadingBarService,
		private cdr: ChangeDetectorRef,
		@Inject(PLATFORM_ID) private platformId: Object,
		private _sanitizer: DomSanitizer,
		private translate: TranslateService,
		private authService: AuthService,
		private iframeService: IframeService,
		private cartService: ShopCartService,
		private sharedDataService: SharedDataService,
		@Inject(LOCAL_STORAGE) private storage: StorageService,
		public router: Router,
		private titleService: Title,
		private activatedRoute: ActivatedRoute,
		private guardService: RouteGuardService,
		private wishlistService: WishlistService,
		private accountservice: AccountService) {
		this.loading = true;
		this.sharedDataService.currentCommondata.subscribe((data: any) => {
			if (data?.googletmid) {
				this.googletagmanager = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.googletagmanager.com/ns.html?id=' + data.googletmid);
			}


			if (data?.env !== undefined) {
				this.dev = data.env === StoreEnv.DEV;
			}
		});

		this.sharedDataService.currentLoggedUser.subscribe(data => {
			this.loggedUser = data as unknown as Customer;
			if (this.loggedUser) {

				this.cartService.loadUserCart(this.loggedUser);

				this.iframeService.postMessage({
					event: 'setUser',
					data: { customer: this.loggedUser }
				}, environment.baseURL);


			}
		});


		this.setUrl();
	}

	ngAfterViewInit(): void {
		this.router.events.pipe(
			filter(event => {
				const routerUrl = event['urlAfterRedirects'];
				if (routerUrl && typeof routerUrl === 'string') {
					ga('set', 'page', event['urlAfterRedirects']);
					ga('send', 'pageview');
				}
				return event instanceof NavigationEnd;
			}));
	}

	ngOnInit(): void {
		this.cartService.initShop(environment.storecode);
		this.wishlistService.initShop(environment.storecode);

		if (isPlatformBrowser(this.platformId)) {
			// FIXME hack per nascondere la progress bar, non mi riesce di capire perché non va via
			setTimeout(t => {
				this.hidebar = true;
				this.cdr.detectChanges();
			}, 6000);
			setTimeout(() => {
				if (this.loading) {
					console.warn(
						`Still loading… Check the environment. If the main site and the personal area are not on the same domain, the baseURL (currently ${environment.baseURL}) must exactly match the URL where the main site is running (including the trailing "/"). The site must be up, and the "/sso" route must render the SSO component. The vue app must be configured with VUE_APP_MYACCOUNT_URL matching the domain in which this app is running (currently ${location.protocol + '//' + location.host}). To run the app locally without the main site, set "runisolated: true" in the environment.`
					);


				}
			}, 10000);
		}

	}

	checkState() {
		console.log('runisolated', environment.runisolated);
		if (this.checked) {
			return;
		}
		this.checked = true;
		if (!environment.runisolated) {//runisolated vuol dire che lo sto mandando localmente senza il sito, solo per sviluppo
			if (this.sameDomain) {
				if (!this.authService.hasCookie()) {

					this.loading = false;
					this.redirectToLogin();


				} else {
					const uid = this.authService.getUid();
					let language = this.storage.get('YF-lang-' + environment?.storecode);

					if (!language) {
						language = 'it';
					}
					this.sharedDataService.setLanguage(language);
					this.translate.setDefaultLang(language);
					this.translate.use(language);
					this.setTitle();

					this.authService.getUser(uid).subscribe(result => {
						this.authService.setLoggedUser(result);
						this.cartService.loadCart(true);

						this.loading = false;
					}, () => this.loading = false);
				}
			} else {
				this.initIframe();
			}
		} else {
			this.authService.getLoggedUser().subscribe((user: any) => {


				if (!user) {
					this.redirectToLogin();
				}
				this.loading = false;
				//window.location.href = environment.baseURL + environment.loginredirecturl;


			})
		}
	}


	redirectToLogin() {
		this.accountservice.logout(false, false);
		if (this.url !== 'account/login') {
			this.router.navigateByUrl('account/login');
			//window.location.href = environment.baseURL + environment.loginredirecturl;

		}
	}
	setUrl() {
		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.pipe(map(() => this.activatedRoute))
			.pipe(map(route => {
				while (route.firstChild) {
					route = route.firstChild;
				}
				return route;
			}))
			.pipe(filter(route => route.outlet === 'primary'))
			.pipe(mergeMap(route => route.data))
			.subscribe(() => {
				this.url = this.router.url;
				console.log('url', this.url);
				this.checkState();
			});
	}

	setTitle() {
		this.translate.get('usertitle').subscribe((data: string) => {
			const t = data;
			this.titleService.setTitle(t + ' | ' + environment.shopname);
		});
	}


	initIframe() {
		window.addEventListener('message', (event: any) => {

			console.log('angular received an event', event.origin, event.data?.event);
			if (event.origin !== this.baseURL)
				return;

			const eventData = event.data;
			if (eventData.event === 'setJWT') {
				const data = eventData.data;
				// TODO maybe better an error page when cartid is empty
				if (!data.token || !data.cartid) {

					this.loading = false;
					this.redirectToLogin();
					//window.location.href = environment.baseURL + environment.loginredirecturl;

				} else {
					this.authService.setTokenCookie(data.token);
					this.cartService.setCartid(data.cartid);

					this.storage.set('yf-vat-country-' + environment?.storecode, data.vatcountry);

					let lang = data.language;
					if (!lang) {
						lang = 'it';
					}
					this.sharedDataService.setLanguage(data.language);
					this.translate.setDefaultLang(data.language);
					this.translate.use(data.language);
					this.setTitle();

					if (data.impersonated) {
						this.authService.setImpersonateToken(data.token, false);

						this.authService.getLoggedUser().subscribe((result: Staff) => {
							if (result) {
								result.impersonated = true;
								this.authService.setLoggedUser(result);
								this.cartService.loadCart(true);
								this.loading = false;
							} else {
								window.location.href = environment.baseURL + environment.loginredirecturl;
							}
						}, () => this.loading = false);
					} else {
						this.authService.getUser(data.uid).subscribe((result: Staff) => {
							this.authService.setLoggedUser(result);
							this.cartService.loadCart(true);
							this.loading = false;
						}, () => this.loading = false);
					}


				}
			} else if (eventData.event === 'logout') {
				this.authService.asynclogout().subscribe(() => {
					this.cartService.clearData();
					//	this.wishlistService.clearData();
					this.guardService.reset();
					window.location.href = environment.baseURL;
					/*	this.iframeService.postMessage({ event: 'logout' }, environment.baseURL);*/

				});
			}
			else if (eventData.event === 'stopimpersonate') {
				this.authService.stopImpersonate();

			}
		}, false);
	}

	stopimpersonate() {
		this.iframeService.postMessage({
			event: 'stopimpersonate',
			data: {}
		}, this.baseURL);
	}


	onIframeLoad(event: Event) {
		this.iframeService.setRef(<HTMLIFrameElement>event.target);
		this.iframeService.postMessage({
			event: 'getJWT',
			data: {}
		}, this.baseURL);
	}

	get baseURL() {
		return environment.baseURL;
	}

	get sameDomain() {
		return this.baseURL.indexOf(window.location.origin) === 0;
	}

}
